export default class UpdateUserRolesRequest {
    roleIds: string[] = [];
    globalAdmin: boolean = false;
}